import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import {FormattedMessage} from "react-intl";

// Material UI
import { Grid } from "@mui/material";

// Components
import Popup from "components/WMS/Mobile/Popup";
import CustomButton from "components/CustomButton";

// Assets
import EndMission from "assets/img/wms/end_mission.svg";

// Utils
import {WMSRoutes} from "utils/WMSRoutes";

EndPickingMissionPopup.propTypes = {
    open: PropTypes.bool.isRequired,
};

function EndPickingMissionPopup({open}) {
    const history = useHistory();

    const Icon = () => (
        <img
            src={EndMission}
            alt={"End picking mission"}
            style={{
                width: '48px',
                height: '48px',
            }}
        />
    );
    return (
        <Popup
            open={open}
            icon={(<Icon />)}
            onClose={() => {}}
            title={<FormattedMessage id={'wms.myPickingMissions.mission.end.popup.title'} />}
            subtitle={<FormattedMessage id={'wms.myPickingMissions.mission.end.popup.subtitle'} />}
            hideCloseIcon={true}
        >
            <Grid container>
                <Grid
                    container
                    item
                    direction={"column"}
                    gap={2}
                >
                    <CustomButton
                        onClick={() => history.push(WMSRoutes.SORTING)}
                        fullWidth={true}
                    >
                        <FormattedMessage id={'wms.myPickingMissions.mission.end.popup.empty'} />
                    </CustomButton>
                    <CustomButton
                        onClick={() => history.push(WMSRoutes.DASHBOARD)}
                        color={'default'}
                        fullWidth={true}
                    >
                        <FormattedMessage id={'wms.myPickingMissions.mission.end.popup.choose'} />
                    </CustomButton>
                </Grid>
            </Grid>
        </Popup>
    );
}

export default EndPickingMissionPopup;
